import {
  FINANCE_ITEM_TYPES,
  FINANCE_ITEM_TYPES_MAP,
  type FinanceItemTypes
} from "../../containers/Project/ProjectViewPage/constants/finance-item-constants.ts"

type FinanceLikeItem = {
  item_type?: FinanceItemTypes | null
  value?: number | string | null
}

type TypeSummary = {
  type: FinanceItemTypes
  label: string
  value: number
}

const TRACKED_TYPES: FinanceItemTypes[] = [
  FINANCE_ITEM_TYPES.RECEIVABLE,
  FINANCE_ITEM_TYPES.PAYABLE
]

function sumByType(
  items: FinanceLikeItem[] | null | undefined
): Map<FinanceItemTypes, number> {
  const result = new Map<FinanceItemTypes, number>()
  if (!items?.length) return result

  for (const item of items) {
    const t = item.item_type ?? null
    if (!TRACKED_TYPES.includes(t as FinanceItemTypes)) continue

    const numeric =
      typeof item.value === "string"
        ? parseFloat(item.value)
        : typeof item.value === "number"
          ? item.value
          : 0

    const value = Number.isFinite(numeric) ? numeric : 0
    if (!value) continue

    result.set(
      t as FinanceItemTypes,
      (result.get(t as FinanceItemTypes) ?? 0) + value
    )
  }

  return result
}

function getTypeSummary(
  items: FinanceLikeItem[] | null | undefined
): TypeSummary[] {
  const byType = sumByType(items)

  return TRACKED_TYPES.reduce<TypeSummary[]>((acc, key) => {
    const sum = byType.get(key)
    if (sum)
      acc.push({
        type: key,
        label: FINANCE_ITEM_TYPES_MAP[key].label,
        value: sum
      })
    return acc
  }, [])
}

function getReceivablePayableTotals(
  items: FinanceLikeItem[] | null | undefined
): { receivable: number; payable: number } {
  const byType = sumByType(items)

  return {
    receivable: byType.get(FINANCE_ITEM_TYPES.RECEIVABLE) ?? 0,
    payable: byType.get(FINANCE_ITEM_TYPES.PAYABLE) ?? 0
  }
}

export type { FinanceLikeItem, TypeSummary }
export { getReceivablePayableTotals, getTypeSummary }
